// Library Imports
import React, { useContext } from 'react'
import { Form } from 'react-bootstrap'
import * as RiIcons from 'react-icons/ri'
// Context Imports
import { DirectoryContext } from '../../contexts/DirectoryContext'
// Asset Imports
import '../../assets/css/stylesheets/components/search/SubCategoryDropDown.css'

function SubCategoryDropDown({ categoryID, selectedValue, onSubCategoryChanged }) {
    const {
        categoryOptions,
        subCategoryOptions,
    } = useContext(DirectoryContext);
    
    return (
        <>
            <div className='subcategorydropdown'>
                <RiIcons.RiStackLine className='subcategorydropdown-icon' />
                <Form.Select
                    className='subcategorydropdown-control'
                    id='subcategoryDropDown'
                    value={selectedValue}
                    onChange={onSubCategoryChanged}>
                    <option value=''>Select Sub Category</option>
                    {
                        categoryOptions.filter(c => c.ID == categoryID).map((category) => {
                            var options = [];
                            subCategoryOptions?.filter(sub => sub.CategoryID == category.ID).map((subcategory) => {
                                options.push(<option value={subcategory.ID}>&nbsp;{subcategory.Name}</option>);
                            })
                            return (options)
                        })
                    }
                </Form.Select>
            </div>
        </>
    )
}

export default SubCategoryDropDown